import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  DispatchChannel,
  DocumentState,
  IDocument,
} from '@kinet-open-network/shared/data-access/model';

export class Document
  extends BaseModel<Document, 'Document'>
  implements IDocument
{
  static override readonly modelName: AbilitySubjectType = 'Document';

  name!: string;
  templateId?: string;
  state!: DocumentState;
  requireSignature!: boolean;
  errorMessage?: string | null;
}

export interface UploadDocumentPayload {
  parentType: string;
  parentId: string;
  name?: string;
  data: string;
}

export interface CreateDocumentPayload {
  parentType: string;
  parentId: string;
  templateId: string;
  name?: string;
  requireSignature?: boolean;
  contextDef?: Record<string, unknown>;
}

export interface SendDocumentPayload {
  channel: DispatchChannel;
  email?: string;
  phoneNumber?: string;
  userId?: string;
  subject?: string;
  body?: string;
  replyTo?: string;
}
